import { useState, useEffect } from 'react';
import React from 'react';
import './Navbar.css';
import logo from '../../../assets/lg_Mj (2).png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isHeaderVisible, setIsHeaderVisible] = useState(true);
    const [isScrolledUp, setIsScrolledUp] = useState(false);
    const location = useLocation();
    let lastScrollY = 0;

    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (typeof window !== 'undefined') {
                const currentScrollY = window.scrollY;

                if (currentScrollY === 0) {
                    setIsScrolledUp(false);
                } else if (currentScrollY < lastScrollY) {
                    setIsScrolledUp(true);
                }

                setIsHeaderVisible(currentScrollY <= lastScrollY);
                lastScrollY = currentScrollY;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const navbarClass = location.pathname === '/productos' ? 'navbar-products' : 'navbar-default';
    const navbarClass2 = location.pathname === '/contacto' ? 'navbar-contacto' : 'navbar-default';
    const navbarClass3 = location.pathname === '/nosotros' ? 'navbar-nosotros' : 'navbar-default';
    const navbarClass4 = location.pathname === '/categoria/:nombre' ? 'navbar-categoria' : 'navbar-default';
    const navbarClass5 = location.pathname === '/categoria/:nombre/:subtitulo' ? 'navbar-detalle' : 'navbar-default';


    return (
        <header
            className={`header ${navbarClass} ${navbarClass2} ${navbarClass3} ${navbarClass4} ${navbarClass5} ${
                isHeaderVisible ? '' : 'hidden'
            } ${isScrolledUp ? 'scrolled-up' : ''}`}
        >
            <a href="/" className="logo">
                <img src={logo} alt="Logo" className="logo-image" />
            </a>

            <div className="menu-toggle" onClick={handleMenuToggle}>
                <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
            </div>
            <nav className={`navbar ${menuOpen ? 'active' : ''}`}>
                <Link to="/" onClick={closeMenu}>
                    Inicio
                </Link>
                <Link to="/productos" onClick={closeMenu}>
                    Productos
                </Link>
                <Link to="/nosotros" onClick={closeMenu}>
                    Nosotros
                </Link>
                <Link to="/contacto" onClick={closeMenu}>
                    Contacto
                </Link>
            </nav>
        </header>
    );
};

export default Navbar;
